import React from 'react';
import styled from 'styled-components';
import ChevronUpDown from '~/images/chevron_up_down.svg';
import SortArrowUp from '~/images/sort_arrow_up.svg';

type Props = {
  label: string;
  direction: 'asc' | 'desc' | 'neutral';
  onClick?: () => void;
};

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
  cursor: pointer;
`;

const HeaderLabel = styled.span``;

const Icon = styled.img`
  height: 1em;
`;

const SortableTableHeader = ({ label, onClick, direction }: Props) => {
  return (
    <HeaderWrapper onClick={onClick}>
      <HeaderLabel>{label}</HeaderLabel>
      {direction === 'neutral' ? (
        <Icon src={ChevronUpDown} alt="Sort by" />
      ) : (
        <Icon
          src={SortArrowUp}
          style={{ transform: `rotate(${direction === 'desc' ? '180deg' : '0'})` }}
        />
      )}
    </HeaderWrapper>
  );
};

export default styled(SortableTableHeader)``;
